module.exports = __webpack_public_path__ + "static/morganstanley-a683c5b19922d85b29b07e849cdde109.png";